import React, { useMemo, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { FormattedMessage, useIntl } from "react-intl";
import { useCallback } from "react";
import { MeasureSelectMask } from "../../../edit-profile/my-measurements";
import formateMeaData from "../../../edit-profile/my-measurements/formateMeasureData";

export default props =>{
    useStyles(cls);
    const { sizeInfomation, commentRules, setSizeInfomation, setSizeChange, message } = props;
    const [showMask, setShowMask] = useState(false)
    const Intl = useIntl()

    const updateComment = useCallback((params) =>{
        setSizeChange(true)
        setSizeInfomation(state=>({ ...state, ...params }));
    }, []);

    const openMask = (type) => {
        const jsonMessage = message? JSON.parse(message): ''
        const data = formateMeaData(jsonMessage, type, Intl)
        let obj = {...data}
        if(sizeInfomation?.[data?.valueLabel]){
            obj['slotDefaultV'] = sizeInfomation?.[data?.valueLabel]
        }
        if(sizeInfomation?.[data?.unitLabel]){
            obj['unit'] = sizeInfomation?.[data?.unitLabel]
        }
        setShowMask(obj)
    }

    return <div className={cls.OrderReviewSizeInfomation}>
        <div className={cls.Title}><FormattedMessage id="my_size_infomation" defaultMessage="My Size Information (Optional)" /></div>
        <div className={cls.Title2}><FormattedMessage id="earn_more_for_size" defaultMessage="Earn more {points} points for fill your all sizes" values={{points: commentRules?.sizeInfoScore}} /></div>
    
        <div className={cls.Container}>
            <div className={cls.SizeItem}>
                <span className={cls.Describe}><FormattedMessage id="height" defaultMessage="Height" />:</span>
                <div className={cls.SizeData} onClick={() => openMask('height')}>
                    {sizeInfomation?.height}
                    <span className={cls.SizeUnit}>{sizeInfomation?.heightUnit}</span>
                </div>
            </div>

            <div className={cls.SizeItem}>
                <span className={cls.Describe}><FormattedMessage id="weight" defaultMessage="Weight" />:</span>
                <div className={cls.SizeData} onClick={() => openMask('weight')}>
                    {sizeInfomation?.weight}
                    <span className={cls.SizeUnit}>{sizeInfomation?.weightUnit}</span>
                </div>
            </div>

            <div className={cls.SizeItem}>
                <span className={cls.Describe}><FormattedMessage id="bust" defaultMessage="Bust" />:</span>
                <div className={cls.SizeData} onClick={() => openMask('bust')}>
                    {sizeInfomation?.bust}
                    <span className={cls.SizeUnit}>{sizeInfomation?.bustUnit}</span>
                </div>
            </div>

            <div className={cls.SizeItem}>
                <span className={cls.Describe}><FormattedMessage id="hips" defaultMessage="Hips" />:</span>
                <div className={cls.SizeData} onClick={() => openMask('hips')}>
                    {sizeInfomation?.hips}
                    <span className={cls.SizeUnit}>{sizeInfomation?.hipsUnit}</span>
                </div>
            </div>

            <div className={cls.SizeItem}>
                <span className={cls.Describe}><FormattedMessage id="waist" defaultMessage="Waist" />:</span>
                <div className={cls.SizeData} onClick={() => openMask('waist')}>
                    {sizeInfomation?.waist}
                    <span className={cls.SizeUnit}>{sizeInfomation?.waistUnit}</span>
                </div>
            </div>
        </div>

        <MeasureSelectMask
            show={showMask}
            onClose={() => setShowMask(null)}
            onConfirm={(data, unit) => {
                let params = {}
                params[showMask.valueLabel] = data
                params[showMask.unitLabel] = unit
                updateComment(params)
                setShowMask(null)
            }}
            />
    </div>
}